/* eslint-disable */
import wrapper from 'wrapper';
import * as d3Selection from 'd3-selection';
import * as d3Geo from 'd3-geo';
import View from './view';

export default class LocatorView extends View {
    constructor(controller, container, config) {
        super(controller, container, config);
        // required
        this.model = this.config.model;
        this.projection = this.config.projection;
        this.dimensions = this.config.dimensions;

        // optional
        this.scaleThreshold = this.config.scaleThreshold || 1.2;
        this.svgClassName = this.config.svgClassName || 'map__locator-view';
        this.featureClassName = this.config.featureClassName || 'locator-view__feature';
        this.imageOverride = this.config.imageOverride || null;
        this.pulloutReference = d3Selection.select(this.container);
        this.aspectRatio = this.config.aspectRatio;
        this.width = this.dimensions[0] / 4;
        this.height = this.width / this.aspectRatio;

        this.path = d3Geo.geoPath()
            .projection(this.projection);

        this.geographyRendered = false;
        this.controller.addTopicHandler('zoom-change', this.zoomChangeHandler.bind(this));
    }

    render() {
        if (this.svg) {
            this.svg.node().remove();
        }

        this.svg = d3Selection.select(this.container)
            .append('div')
            .attr('class', 'locator-view__container')
            .append('svg')
            .attr('class', this.svgClassName)
            .attr('role', 'presentation')
            .attr('preserveAspectRatio', 'xMidYMid meet')
            .attr('viewBox', `0 0 ${this.dimensions[0]} ${this.dimensions[1]}`)
            .attr('width', this.width)
            .attr('height', this.height);

        this.group = this.svg
            .append('g')
            .attr('class', 'locator-view__map');

        this.viewportIndicator = this.svg
            .append('rect')
            .attr('x', 0)
            .attr('y', 0)
            .attr('width', this.dimensions[0])
            .attr('height', this.dimensions[1])
            .attr('fill', 'white')
            .attr('fill-opacity', 0.2)
            .attr('stroke', 'black')
            .attr('stroke-width', 1)
            .classed('locator__viewport-indicator', true);
    }

    renderGeography(hasIndividualFeaturePaths) {
        const multiplePaths = hasIndividualFeaturePaths || false;
        let selection = this.group;
        let viewportFillFactor;

        if (multiplePaths) {
            selection = selection.selectAll('.map__feature')
                .data(this.model.features)
                .enter()
                .append('path')
                .attr('vector-effect', 'non-scaling-stroke')
                .on('click', (d, i, s) => {
                    this.emit('focus-feature', {
                        feature: d,
                        node: s[i],
                        viewportFillFactor: viewportFillFactor,
                    });
                });
        }
        else {
            viewportFillFactor = 1;
            selection = selection
                .datum(this.model)
                .append('path');
            this.svg
                .on('click', () => {
                    this.emit('reset-map');
                });
        }

        selection
            .attr('d', this.path)
            .attr('class', (d) => this.getFeatureClassName(d));

        this.geographyRendered = true;
        return selection;
    }

    getFeatureClassName(feature) {
        const id = (feature && feature.id) ? feature.id.toLowerCase() : 'no-id';

        const idClass = `${this.featureClassName}--${id}`;
        const className = `${this.featureClassName} ${idClass}`;

        return className;
    }

    show() {
        if (!this.geographyRendered) {
            this.renderGeography();
        }

        this.showLocator(true);
        this.showPullout(true);
    }

    hide() {
        this.showLocator(false);
        this.showPullout(false);
    }

    showLocator(bool) {
            if (bool) {
                wrapper.select('.locator-view__container').classList.add(`locator-view__container--active`);
            } else {
                wrapper.select('.locator-view__container').classList.remove(`locator-view__container--active`);
            }

        this.svg
            .classed(`${this.svgClassName}--active`, bool);
    }

    showPullout(bool) {
        this.pulloutReference
            .select('.map__pullout-view')
            .classed('map__pullout-view--inactive', bool);
    }

    zoomChangeHandler(event) {
        const transform = event.transform;
        if (transform.k < this.scaleThreshold) {
            this.hide();
        }
        else {
            this.show();
        }

        this.viewportIndicator
            .attr('x', -transform.x / transform.k)
            .attr('y', -transform.y / transform.k)
            .attr('width', this.dimensions[0] / transform.k)
            .attr('height', this.dimensions[1] / transform.k);
    }
}
